export default __webpack_public_path__ + "static/media/PolishingImg.859134e0.jpg";